import React, { useEffect, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";

// JS Files
import MuiButton from "../shares/MuiButton";
import MuiDrawer from "../shares/MuiDrawer";
import MuiDropDown from "./MuiDropDown";

// Others File
import logo from "../../imgs/logo.svg";
import logoMobile from "../../imgs/logo-mobile.svg";
import { useAuth } from "../../context/AuthContext";

const items = [
  {
    name: "پورتال رفاپ",
    address: "https://portal.rfap.ir/login",
  },
  {
    name: "پورتال درمان",
    address: "http://darman.rfap.ir",
  },
];
const Navbar = (props) => {
  const { token, authDispatch } = useAuth();
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer = () => {
    setOpenDrawer((before) => !before);
  };
  return (
    <>
      {/* Desktop Navbar */}
      <div className="hidden md:flex md:justify-between md:items-center md:mx-16 md:mb-2">
        <div className="pb-2 basis-1/12">
          <img src={logo} />
        </div>
        <div className="flex justify-center items-center basis-10/12">
          <div
            className={
              props.activePage == "homepage" ? "nav-item-active" : "nav-item"
            }
            onClick={() => navigate("/")}
          >
            <span className="">صفحه اصلی</span>
          </div>
          <div
            className={
              props.activePage == "aboutus"
                ? "mr-16 nav-item-active"
                : "mr-16 nav-item"
            }
            onClick={() => navigate("/aboutus")}
          >
            <span className="">درباره ما</span>
          </div>
          <div
            className={
              props.activePage == "contactus"
                ? "mr-16 nav-item-active"
                : "mr-16 nav-item"
            }
            onClick={() => navigate("/contactus")}
          >
            <span className="">تماس با ما</span>
          </div>
          <a href="https://medu.ir/#news" target="_blank">
            <div className="mr-16 nav-item">
              <span className="">اخبار</span>
            </div>
          </a>

          <div
            className={
              props.activePage == "notifications"
                ? "mr-16 nav-item-active"
                : "mr-16 nav-item"
            }
            onClick={() => navigate("/notifications")}
          >
            <span className="">اطلاعیه ها</span>
          </div>
          <div
            className={
              props.activePage == "rules"
                ? "mr-16 nav-item-active"
                : "mr-16 nav-item"
            }
            onClick={() => navigate("/rules")}
          >
            <span className="">قوانین و مقررات</span>
          </div>
        </div>
        {token == null ? (
          <div>
            <MuiDropDown name="پورتال‌ها" items={items} />
          </div>
        ) : (
          <MuiButton
            onClick={() => authDispatch({ type: "LOGOUT" })}
            variant="contained"
            color="primary"
            text="خروج"
          />
        )}
      </div>
      {/* Mobile Navbar */}
      <div className="flex justify-between items-center px-4 py-4 md:hidden">
        <img src={logoMobile} />
        <MenuIcon
          className="text-myblue-400 cursor-pointer"
          onClick={() => toggleDrawer()}
        />
      </div>
      <MuiDrawer
        anchor="right"
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
      >
        <div className="h-full w-72  py-4 hp-section-one">
          <div className="flex justify-center">
            <img src={logo} />
          </div>
          <div className="pr-8">
            <div
              className={
                props.activePage == "homepage"
                  ? "mt-8 nav-item-active"
                  : "mt-8 nav-item"
              }
              onClick={() => navigate("/")}
            >
              <span className="">صفحه اصلی</span>
            </div>
            <div
              className={
                props.activePage == "contactus"
                  ? "mt-4 nav-item-active"
                  : "mt-4 nav-item"
              }
              onClick={() => navigate("/aboutus")}
            >
              <span className="">درباره ما</span>
            </div>
            <div
              className={
                props.activePage == "contactus"
                  ? "mt-4 nav-item-active"
                  : "mt-4 nav-item"
              }
              onClick={() => navigate("/contactus")}
            >
              <span className="">تماس با ما</span>
            </div>
            <a href="https://medu.ir/#news" target="_blank">
              <div className="mt-4 nav-item">
                <span className="">اخبار</span>
              </div>
            </a>

            <div
              className={
                props.activePage == "notifications"
                  ? "mt-4 nav-item-active"
                  : "mt-4 nav-item"
              }
              onClick={() => navigate("/notifications")}
            >
              <span className="">اطلاعیه ها</span>
            </div>
            <div
              className={
                props.activePage == "rules"
                  ? "mt-4 nav-item-active"
                  : "mt-4 nav-item"
              }
              onClick={() => navigate("/rules")}
            >
              <span className="">قوانین و مقررات</span>
            </div>
            {token == null ? (
              <>
                <a href="https://portal.rfap.ir/login" target="_blank">
                  <div className="mt-4 nav-item">
                    <span className="">پورتال رفاپ</span>
                  </div>
                </a>
                <a href="http://darman.rfap.ir" target="_blank">
                  <div className="mt-4 nav-item">
                    <span className="">پورتال درمان</span>
                  </div>
                </a>
              </>
            ) : (
              <div className="mt-4">
                <MuiButton
                onClick={() => authDispatch({ type: "LOGOUT" })}
                variant="contained"
                color="primary"
                text="خروج"
              />
              </div>
            )}
          </div>
        </div>
      </MuiDrawer>
    </>
  );
};
export default Navbar;
